export function ClientFeedbackMissingTarget() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6 text-center text-sm text-muted-foreground">
      <p>
        Add a{' '}
        <code className="rounded bg-muted px-1 py-0.5 font-mono text-xs">
          targetUrl
        </code>
      </p>
    </div>
  );
}
